import React from 'react';
import { Drawer } from 'antd';
import { ReactComponent as Close } from '../../../../../resources/images/svg/close.svg';
import './DefaultDrawer.scss';

function DefaultDrawer({
  title,
  setShow,
  show,
  children,
  className,
  style = {},
  wrapperStyle = {},
  wrapperClassName = '',
}) {
  return (
    <Drawer
      title={title}
      placement="bottom"
      onClose={() => setShow(false)}
      closeIcon={<Close />}
      open={show}
      maskStyle={{
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
      }}
      contentWrapperStyle={{
        boxShadow: 'none',
        ...wrapperStyle,
      }}
      drawerStyle={style}
      className={`default-drawer ${className}`}
      wrapperClassName={wrapperClassName}
    >
      {children}
    </Drawer>
  );
}

export default DefaultDrawer;
